/** Assessment list + taking-flow chrome. Instrument names live in catalogs/assessments.js. */
const dictionary = {
  en: {
    listTitle: "Assessments",
    listSubtitle: "Takes 15-20 min per assessment.",
    categories: {
      personality: "Personality",
      adept: "Adept-15",
      reasoning: "Reasoning and skills",
      languages: "Languages",
    },
    duration: "15 min",
    progressTaken: "You’ve taken {completed} of {required} required assessments",
    progressTooltip:
      "Please complete these assessments before proceeding",
    required: "Required",
    requiredTooltip: "Please complete this assessment to proceed further",
    viewResults: "View your results",
    retakeTest: "Retake the test",
    doThisAssessment: "Do this assessment",
    instructions: "Instructions",
    selectLanguage: "Select language",
    languageNames: {
      1: "German",
      2: "English",
      3: "French",
      4: "Italian",
      6: "Norwegian",
      7: "Romanian; Moldavian; Moldovan",
      8: "Dutch; Flemish",
      9: "Spanish; Castilian",
      10: "Portuguese",
      11: "Swedish",
      13: "Polish",
      14: "Czech",
      15: "Russian",
      16: "Danish",
      17: "Finnish",
      18: "Greek",
      19: "Chinese",
      21: "Arabic",
      29: "Slovak",
    },
    rememberChoice: "Remember my choice for later tests",
    startTest: "Start test",
    retake: "Retake",
    retakeAssessments: "Retake Assessments",
    retakeWarning:
      "Pressing Retake Button will reset results for this assessment.",
    noInstructions: "No instructions available.",
    alreadyCompleted: "You have already completed this test",
    importance: "Importance",
    whatItMeasures: "What it measures",
    results: "Results",
    overallScore: "Your overall test score is:",
    loadingResults: "Loading Results...",
    loadingResultsBody: "Please wait while we load your assessment results.",
    generateReport: "Generate Report",
    downloadReportTitle: "Download report in your preferred language",
    downloadIn: "Download in {language}",
    reportUnavailable: "This report is not available in {language}",
    instructionItems: [
      "Find a quiet place where you will not be interrupted",
      "Set aside about 15 minutes",
      "Use Chrome on a computer if possible",
      "Answer honestly — there are no right or wrong personality answers",
    ],
  },
  de: {
    listTitle: "Assessments",
    listSubtitle: "Dauert 15–20 Minuten pro Assessment.",
    categories: {
      personality: "Persönlichkeit",
      adept: "Adept-15",
      reasoning: "Kognitive Fähigkeiten",
      languages: "Sprachen",
    },
    duration: "15 Min.",
    progressTaken:
      "Sie haben {completed} von {required} erforderlichen Assessments absolviert",
    progressTooltip:
      "Bitte schließen Sie diese Assessments ab, bevor Sie fortfahren",
    required: "Erforderlich",
    requiredTooltip:
      "Bitte schließen Sie dieses Assessment ab, um fortzufahren",
    viewResults: "Ergebnisse ansehen",
    retakeTest: "Test wiederholen",
    doThisAssessment: "Dieses Assessment durchführen",
    instructions: "Anleitung",
    selectLanguage: "Sprache wählen",
    languageNames: {
      1: "Deutsch",
      2: "Englisch",
      3: "Französisch",
      4: "Italienisch",
      6: "Norwegisch",
      7: "Rumänisch",
      8: "Niederländisch",
      9: "Spanisch",
      10: "Portugiesisch",
      11: "Schwedisch",
      13: "Polnisch",
      14: "Tschechisch",
      15: "Russisch",
      16: "Dänisch",
      17: "Finnisch",
      18: "Griechisch",
      19: "Chinesisch",
      21: "Arabisch",
      29: "Slowakisch",
    },
    rememberChoice: "Meine Auswahl für spätere Tests merken",
    startTest: "Test starten",
    retake: "Wiederholen",
    retakeAssessments: "Assessments wiederholen",
    retakeWarning:
      "Wenn Sie auf Wiederholen klicken, werden die Ergebnisse dieses Assessments zurückgesetzt.",
    noInstructions: "Keine Anleitung verfügbar.",
    alreadyCompleted: "Sie haben diesen Test bereits abgeschlossen",
    importance: "Bedeutung",
    whatItMeasures: "Was wird gemessen",
    results: "Ergebnisse",
    overallScore: "Ihr Gesamtergebnis ist:",
    loadingResults: "Ergebnisse werden geladen...",
    loadingResultsBody:
      "Bitte warten Sie, während wir Ihre Assessment-Ergebnisse laden.",
    generateReport: "Bericht erstellen",
    downloadReportTitle: "Bericht in Ihrer bevorzugten Sprache herunterladen",
    downloadIn: "Herunterladen auf {language}",
    reportUnavailable: "Dieser Bericht ist auf {language} nicht verfügbar",
    instructionItems: [
      "Suchen Sie einen ruhigen Ort, an dem Sie nicht unterbrochen werden",
      "Nehmen Sie sich etwa 15 Minuten Zeit",
      "Nutzen Sie nach Möglichkeit Chrome auf Ihrem Computer",
      "Antworten Sie ehrlich — bei Persönlichkeitsfragen gibt es kein Richtig oder Falsch",
    ],
  },
  "fi": {
    "listTitle": "Arvioinnit",
    "listSubtitle": "Kunkin arvioinnin kesto on 15–20 minuuttia.",
    "categories": {
      "personality": "Persoonallisuus",
      "adept": "Adept-15-osa-alueet",
      "reasoning": "Päättely ja taidot",
      "languages": "Kielet"
    },
    "duration": "15 min",
    "progressTaken": "Olet suorittanut {completed} / {required} vaadittua arviointia",
    "progressTooltip": "Suorita nämä arvioinnit ennen kuin jatkat",
    "required": "Pakollinen",
    "requiredTooltip": "Suorita tämä arvio jatkaaksesi",
    "viewResults": "Tarkastele tuloksiasi",
    "retakeTest": "Tee testi uudelleen",
    "doThisAssessment": "Tee tämä arviointi",
    "instructions": "Ohjeet",
    "selectLanguage": "Valitse kieli",
    "languageNames": {
      "1": "Saksa",
      "2": "Englanti",
      "3": "Ranska",
      "4": "Italia",
      "6": "Norja",
      "7": "Romania",
      "8": "Hollanti",
      "9": "Espanja",
      "10": "Portugali",
      "11": "Ruotsi",
      "13": "Puola",
      "14": "Tšekki",
      "15": "Venäjä",
      "16": "Tanska",
      "17": "Suomi",
      "18": "Kreikka",
      "19": "Kiina",
      "21": "Arabia",
      "29": "Slovakki"
    },
    "rememberChoice": "Muista valintani myöhempiä testejä varten",
    "startTest": "Aloita testi",
    "retake": "Tee uudelleen",
    "retakeAssessments": "Tee arvioinnit uudelleen",
    "retakeWarning": "Tee uudelleen -painike nollaa tämän arvioinnin tulokset.",
    "noInstructions": "Ohjeita ei ole saatavilla.",
    "alreadyCompleted": "Olet jo suorittanut tämän testin",
    "importance": "Merkitys",
    "whatItMeasures": "Mitä testi mittaa",
    "results": "Tulokset",
    "overallScore": "Testin kokonaispistemääräsi on:",
    "loadingResults": "Ladataan tuloksia...",
    "loadingResultsBody": "Odota, kun lataamme arviointitulokset.",
    "generateReport": "Luo raportti",
    "downloadReportTitle": "Lataa raportti haluamallasi kielellä",
    "downloadIn": "Lataa ({language})",
    "reportUnavailable": "Tätä raporttia ei ole saatavilla valitulla kielellä ({language})",
    "instructionItems": [
      "Etsi hiljainen paikka, jossa sinua ei häiritä",
      "Varaa aikaa noin 15 minuuttia",
      "Käytä mieluiten Chrome-selainta tietokoneella",
      "Vastaa rehellisesti – persoonallisuuskysymyksiin ei ole oikeita tai vääriä vastauksia"
    ]
  }
};

export default dictionary;
